import { RecuperarSenhaModel } from 'projects/core/src/lib/core/model/RecuperarSenhaModel';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { UsuarioProvider } from 'projects/core/src/lib/core/provider/UsuarioProvider';

import { LoginModel } from 'projects/core/src/lib/core/model/LoginModel';

import { validate } from 'projects/core/src/lib/core/ValidateCPF'
import { LoginPage } from 'src/pages/login/login.page';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { HomeMenuModel } from 'projects/core/src/lib/core/model/HomeMenuModel';
import { TokenModel } from 'projects/core/src/lib/core/model/TokenModel';
import { UltimoLoginModel } from 'projects/core/src/lib/core/model/UltimoLoginModel';
import { MaskCPF } from 'projects/core/src/lib/core/MaksCPF';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';

export class LoginViewModel {

    constructor() { }

    context: LoginPage
    usuarioModel = new UsuarioModel()
    usuarioProvider = new UsuarioProvider()
    loginModel = new LoginModel()
    recuperarSenhaModel = new RecuperarSenhaModel()
    homeMenuModel = new HomeMenuModel()

    async processoLogin(loginModelAux: LoginModel) {

        let loginModel = new LoginModel()
        loginModel.usuario = loginModelAux.usuario.trim()
        const validacaoCpf = validate(this.limpaCaracteresCpf(loginModel.usuario))
        if (validacaoCpf) {
            loginModel.usuario = this.limpaCaracteresCpf(loginModel.usuario)
        }
        loginModel.senha = loginModelAux.senha

        const retorno = await this.loginModel.loginUsuario(loginModel);
        if (retorno.status == ResponseModel.STATUS_OK) {
            await this.criaSessaoToken(retorno.data)
            await this.criaSessaoUltimoLogin(loginModel)
        }

        switch (retorno.status) {
            case ResponseModel.STATUS_OK:
                try {
                    await this.processoObtemInformacoesUsuario()
                    await this.getContext().processoUsuarioAutenticado()
                } catch (e) {
                    throw Error(ThrowError.MESSAGE_DEFAULT)
                }
                break;
            case ResponseModel.STATUS_UNAUTHORIZED:
                throw new Error('Usuário e/ou senha inválidos.')
            default:
                throw new Error('Não foi possível processar sua solicitação no momento. Tente novamente')
        }
    }

    getContext(): LoginPage {
        return this.context
    }

    setContext(context: LoginPage) {
        this.context = context
    }

    criaSessaoUltimoLogin(loginModel: LoginModel) {
        let ultimoLogin = {
            usuario: loginModel.usuario
        }
        AppStorage.set(AppSession.CHAVE_ULTIMO_LOGIN, ultimoLogin)
    }

    async processoObtemInformacoesUsuario() {
        const retorno = await this.usuarioProvider.informacoesUsuario();
        if (retorno.status == ResponseModel.STATUS_OK) {
            await this.criaSessaoUsuario(retorno.data)
        } else {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }


    async obtemCarroseis() {
        const retorno = await this.loginModel.getCarrosseis();
        if (retorno.status == ResponseModel.STATUS_OK) {
            await this.criaSessaoUsuario(retorno.data)
        } else {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }


    async criaSessaoToken(tokenModel: TokenModel) {
        await AppSession.saveToken(tokenModel);
    }

    async criaSessaoUsuario(usuarioModel: UsuarioModel) {
        await AppSession.saveUser(usuarioModel);
    }

    async obtemUsuarioLogado(): Promise<UsuarioModel> {
        return await AppSession.getUser()
    }

    async obtemUltimoLogin(): Promise<UltimoLoginModel> {
        return await AppStorage.get(AppSession.CHAVE_ULTIMO_LOGIN)
    }

    verificaUsuarioLogado() {
        return this.obtemUsuarioLogado() ? true : false
    }

    validaUsuario(loginModel: LoginModel) {
        const validacaoCpf = validate(this.limpaCaracteresCpf(loginModel.usuario))
        const validacaoEmail = this.validateEmail(loginModel.usuario)
        return validacaoCpf || validacaoEmail
    }

    mascaraCPF(cpf) {
        cpf = cpf.replace(/\D/g, "")
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
        return cpf
    }

    limpaCaracteresCpf(texto: String) {
        return texto.replace(/[.-]/gi, '')
    }

    textoSoTemNumeros(texto): boolean {
        return /^[0-9]+$/.test(texto)
    }

    mascaraCpfEmail(texto) {
        let aux = texto.trim()
        if (texto) {
            let limpaCaracter = this.limpaCaracteresCpf(texto)
            if (this.textoSoTemNumeros(limpaCaracter.substr(0, 11))) {
                if (limpaCaracter.length > 11) {
                    limpaCaracter = limpaCaracter.substr(0, 11)
                }
                aux = new MaskCPF().cpf_mask(limpaCaracter)
            }
        }
        return aux
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    async setupUsuarioLogado() {
        //await this.criarEstruturaMenuRecomendacoes()
        //await this.configuraTopicsFirebase()
    }

    async setupApp() {
        new Promise(async (resolve, reject) => {
            try {
                if (this.verificaUsuarioLogado()) {
                    await this.setupUsuarioLogado()
                }
                resolve({})
            } catch (e) {
                console.log('>> Error: ', e.getMessage())
                reject()
            }
        })
    }
}